module.exports = __webpack_public_path__ + "static/projectionMap+RFID-629a8b46bcd354e74a54bfdaf6a3d1fd.jpeg";